import React, {memo, useCallback, useMemo, useState} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {SettingSelectComponent} from "../../../../components/Settings/SettingSelectComponent"
import {BridgeDeviceModel} from "../../../../types/bridge-device"
import {SelectItem} from "../../../../components/Select"
import {useDispatch, useSelector} from "react-redux"
import {useLocalization} from "../../../../hooks/localization"
import {useHistory, useParams} from "react-router-dom"
import {useMessage} from "../../../../hooks/message"
import {useRPC} from "../../../../hooks/rpc"
import {BoosterModel} from "../../../../store/control/state"
import {changeBusyAction} from "../../../../store/ui/actions"

export const BoosterDeviceEditScreen = memo(function BoosterDeviceEditScreen() {
    const {t} = useLocalization()
    const {failure, success} = useMessage()
    const [rpc] = useRPC()
    const dispatch = useDispatch()
    const boostedDevicesList = useSelector(state => state.control.boosterList)
    const bridgeDeviceList = useSelector(state => state.control.bridgeDeviceList)
    const history = useHistory()
    const {id} = useParams<{id: string}>()
    const bridgeDeviceOptionList: SelectItem<BridgeDeviceModel>[] = useMemo(
        () => bridgeDeviceList
                .filter(bridgeDevice => bridgeDevice?.type_id !== '18' && !boostedDevicesList.some(r => r.boosted_device_id === bridgeDevice?.id))
                .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
                .map(bridgeDevice => ({
                    value: bridgeDevice,
                    label: bridgeDevice.name
                })),
        [bridgeDeviceList, boostedDevicesList]
    )
    const [bridgeDevice, setBridgeDevice] = useState<SelectItem<BridgeDeviceModel>>(
        bridgeDeviceOptionList.find(bridgeDeviceOption => bridgeDeviceOption.value.id) || null
    )

    const onBackPressed = useCallback(() => history.push(`/settings/device/booster-list/${id}`), [history, id])

    const onClickAddDevice = useCallback(() => {
        if (bridgeDevice == null) {
            failure(t("pls_select_a_device"))
            return false
        }
        const boostedDevice: BoosterModel = {
            boosted_device_id: bridgeDevice?.value?.id,
            booster_id: id
        }
        dispatch(changeBusyAction(true))
        rpc.updateBoostedDeviceList(boostedDevice)
            .then(() => {
                dispatch(changeBusyAction(false))
                success(t("device_successfully_added"))
                onBackPressed()
            })
            .catch(failure)
            .finally(() => dispatch(changeBusyAction(false)))
    }, [onBackPressed, t, failure, success, dispatch, rpc, bridgeDevice, id])

    const button = useMemo(
        () => [
            {
                text: t("add"),
                className: "green",
                onClick: onClickAddDevice
            }
        ],
        [t, onClickAddDevice]
    )

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                className="service-edit"
                buttons={button}
                backUrl={`/settings/device/booster-list/${id}`}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingSelectComponent
                            label={t("device")}
                            options={bridgeDeviceOptionList}
                            onChange={setBridgeDevice}
                            value={bridgeDevice}
                        />
                    </div>
                    <div className="content-wrapper"></div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
